export default __webpack_public_path__ + "static/new-window-after-ae3e5b82004c13c76ff410aeaa1ef6cebe47cee2fdebd4b320ff5f2ed9e263bb.png";